<template>
  <div class="gmdj">
    <div class="content">
      <van-form ref="form">
        <div class="dg">
          <p class="title">在线报修</p>
          <div>
            <van-field
              required
              v-model="formData.repairNo"
              label="墓编号"
              placeholder="编号 或 **排**号"
            />
          </div>
        </div>
        <!---->
        <!---->
        <div class="line"></div>
        <div class="dg">
          <p class="title">说明</p>
          <van-field
            v-model="formData.content"
            rows="1"
            autosize
            label=""
            type="textarea"
            placeholder="请提供更详细的信息，以便更好的为您解决问题。"
          />
          <div class="posting-uploader">
            <template v-for="(item, nn) in formData.gallery">
              <img
                :key="nn"
                :src="item"
                alt="图片"
                class="imgPreview"
                style="width:80px;height:80px;float:left;"
              />
            </template>
            <van-uploader
              :before-read="beforeRead"  
              :after-read="afterRead" />
          </div>
        </div>
      </van-form>
    </div>
    <div class="clearBox"></div>
    <div class="footDiv">
      <div class="btn" style="width: 100%;" @click="submitRepair()">提交报修</div>
    </div>
    <!-- <div data-v-a9eb2a58 class>
      <div data-v-a9eb2a58 class="success">
        <p data-v-a9eb2a58 class="title">预约提交成功</p>
        <span data-v-a9eb2a58 class="text">
          您已成功提交预约
          <br />请在我的订单中查看预约反馈
        </span>
      </div>
    </div> -->
  </div>
</template>

<script>
import * as imageConversion from 'image-conversion'
export default {
  name: 'goumudengji',
  data() {
    return {
      formData: {
        // bianhao: '',

        // imgurl: '',

        // ms: '',
        myId: this.$store.getters.userId,
        repairNo: '',
        content: '',
        gallery: [],
      },
      saveFlag: false,
      show: false,
    }
  },
  computed: {},
  created() {},
  methods: {
    submitRepair() {
      var that = this
      if (that.formData.repairNo == '') {
        that.$toast.fail('请填写墓位编号~')
        return
      }

      this.$submit('/api/msgrepair/addRepair', this.formData, function(res) {
        if (res['code'] === 1) {
          that.$toast.success('提交成功！')
        }
      })
    },
    async beforeRead(file){
      const MAX_SIZE = 300
      if(file.size > (MAX_SIZE+20)*1024){
        return new Promise((resolve, reject) =>{
          imageConversion.compressAccurately(file, MAX_SIZE).then((res) => {
            res = new File([res], file.name);
            resolve(res);
          });
          console.log(reject)
        })
      } else {
        return file
      }
    },
    afterRead(file) {
      var that = this
      this.$upload('MsgRepair', file, { field: 'gallery' }, function(res) {
        console.log(JSON.stringify(res))
        that.formData.gallery.push(res['data']['url'])
      })
    },
  },
  watch: {
    formData: {
      handler() {
        if (this.formData.repairNo) {
          this.saveFlag = true
        } else {
          this.saveFlag = false
        }
      },
      deep: true,
    },
  },
}
</script>
<style>
/* .success {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    visibility: hidden;
    opacity: 0;
    transition: all 1s ease;
    border: 1px solid #eee;
    width: 22rem;
    padding: 3rem 1rem;
    font-size: 1.4rem;
    border-radius: .5rem;
    text-align: center;
    background: #fff;
    box-shadow: 1px 2px 5px rgb(0 0 0 / 20%);
}
.success .title {
    color: #15a892;
}
.success .text {
    color: #999;
    line-height: 2.4rem;
    margin-top: 2.4rem;
    display: block;
} */
.gmdj .van-field__control {
  text-align: right;
}
.gmdj .jiantou {
  position: absolute;
  right: 2rem;
  top: 6.5rem;
}
.gmdj .content {
  padding: 1rem;
  font-size: 1.6rem;
}
.gmdj .dg {
  padding: 0 1.5rem 0.2rem;
  background-color: #fff;
}
.gmdj .dg .title {
  padding: 1.3rem 0;
  line-height: 2rem;
}
.gmdj .line {
  width: 100%;
  height: 1rem;
}

.gmdj .line {
  width: 100%;
  border-bottom: 1px solid #eee;
}
.gmdj .clearBox {
  clear: both;
  height: 5rem;
}
.gmdj .footDiv {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 5rem;
  line-height: 5rem;
  font-size: 1.6rem;
  background-color: #fff;
  display: flex;
  justify-content: flex-end;
}
.gmdj .footDiv .btn {
  width: 13.5rem;
  font-size: 1.4rem;
  text-align: center;
  background-color: #15a892;
  color: #fff;
  width: 100%;
}
</style>
